import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[RateCard SetFilter] Action',
  ResetFilter: '[RateCard ResetFilter] Action',
}

const initialRateCardState: IRateCardState = {
  filter: {
    status: 'active',
    active: true,
  },
}

export interface IRateCardState {
  filter?: {
    status: string
    active: boolean
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-RateCard', whitelist: ['filter']},
  (state: IRateCardState = initialRateCardState, action: ActionWithPayload<IRateCardState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialRateCardState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
